module.exports = __webpack_public_path__ + "img/sprite.symbol.255a01f9.svg";